import styled from "styled-components";
import Variables from "../../assets/styleVariables";

const WIDTH = "160px";
const CALENDAR_HEADER = "54px";
const MAIN_DARK_COLOR = Variables.colors.tertiary_600;
const MAIN_LIGHT_COLOR = Variables.colors.tertiary_50;
export const Box = styled.div`
  font-family: Number, sans-serif;
  position: relative;
  width: ${WIDTH};
  & > i {
    cursor: pointer;
    position: absolute;
    right: 130px;
    top: calc(50% - 8px);
    color: ${props =>
      props.iconStaus ? MAIN_DARK_COLOR : Variables.colors.complementary_700};
    transition: 0.2s;
    transform: ${props => {
      if (!props.status) {
        return `rotate(180deg)`;
      }
    }};
    &.calendar-icon {
      &:before {
        font-size: 16px;
      }
    }
  }
  .notice {
    margin-bottom: 8px;
    margin-top: 8px;
    display: block;
    padding: 4px 0;
    font-size: ${Variables.font_sizes.x_small};
    color: ${Variables.colors.red_600};
  }
`;

export const SelectBut = styled.button`
  background-color: ${Variables.colors.complementary_250};
  width: ${WIDTH};
  height: 42px;
  border-radius: 4px;
  border: none;
  position: relative;
  padding: 8px;
  font-size: ${Variables.font_sizes.x_medium};
  line-height: 23px;
  text-align: right;
  cursor: pointer;
  &:focus {
    border-bottom: 2px solid ${MAIN_DARK_COLOR};
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export const DatePickerDropdown = styled.div`
  position: absolute;
  z-index: 999;
  padding-bottom: 8px;
`;

export const DatePickerDropdownMenu = styled.div`
  width: auto !important;
  height: 320px;
  border: none;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 #cccccc;
  background-color: ${Variables.colors.white};
`;

export const SingleDatePartPickerDropdownMenu = styled.div`
  width: auto !important;
  height: 240px;
  border: none;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 #cccccc;
  background-color: ${Variables.colors.white};
  padding: 16px 0;
`;

export const Arrow = styled.i`
  font-size: 12px;
  color: ${Variables.colors.complementary_900};
  top: 12px;
  position: absolute;
  cursor: pointer;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  :hover {
    background-color: ${Variables.colors.complementary_100};
  }
`;
export const ArrowLeft = styled(Arrow)`
  left: 5px;
`;
export const ArrowRight = styled(Arrow)`
  left: 52px;
`;
export const ArrowDown = styled(Arrow)`
  position: static;
  margin-right: 4px;
`;
export const CalendarContainer = styled.div`
  height: calc(
    100% - ${props => (props.withoutHeader ? "0px" : CALENDAR_HEADER)}
  );
`;
export const CalendarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${CALENDAR_HEADER};
`;
export const CalendarGrid = styled.div`
  display: grid;
  height: 100%;
  overflow-y: auto;
`;
export const CalendarSelectedMonthYear = styled.div`
  text-align: right;
  padding: 12px 16px;
  margin-top: 0;
  color: ${Variables.colors.black};
  font-weight: bold;
  font-size: 0.944rem;
`;

export const CalendarDayCell = styled.div`
  text-align: center;
  grid-column: ${props => (props.index % 7) + 1} / span 1;
  border-radius: 20px;
  margin: 0.166rem 0.4rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  &:nth-child(n + 1):nth-child(-n + 7) {
    font-size: ${Variables.font_sizes.small};
    color: ${Variables.colors.complementary_700};
  }
  &:nth-child(7n) {
    color: ${MAIN_DARK_COLOR};
  }
`;
export const CalendarDate = styled(CalendarDayCell)`
  cursor: pointer;
  visibility: ${props => (props.inMonth ? `visible` : `hidden`)};
  // grid-row: ${props => Math.floor(props.index / 7) + 2} / span 1;
  :hover {
    background-color: ${Variables.colors.complementary_100};
  }
`;
export const HighlightedCalendarDate = styled(CalendarDate)`
  background-color: ${MAIN_DARK_COLOR};
  color: ${Variables.colors.complementary} !important;
  position: relative;
  &:hover {
    background-color: ${MAIN_DARK_COLOR};
    color: ${Variables.colors.complementary};
  }
`;
export const TodayCalendarDate = styled(HighlightedCalendarDate)`
  background-color: ${MAIN_LIGHT_COLOR};
  color: ${MAIN_DARK_COLOR} !important;
  font-weight: ${Variables.font_weight.medium};
  &:hover {
    background-color: ${MAIN_LIGHT_COLOR};
    color: ${MAIN_DARK_COLOR};
  }
`;

export const CalendarYearCell = styled.div`
  text-align: center;
  grid-column: ${props => (props.index % 4) + 1} / span 1;
  border-radius: 20px;
  margin: 0.166rem 0.4rem;
  width: 4.1rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
  :hover {
    background-color: ${Variables.colors.complementary_100};
  }
`;

export const HighlightedCalendarYear = styled(CalendarYearCell)`
  background-color: ${MAIN_DARK_COLOR};
  color: ${Variables.colors.complementary};
  position: relative;
  &:hover {
    background-color: ${MAIN_DARK_COLOR};
    color: ${Variables.colors.complementary};
  }
`;

export const CalendarMonthCell = styled.div`
  text-align: center;
  grid-column: ${props => (props.index % 3) + 1} / span 1;
  border-radius: 20px;
  margin: 0.166rem 0.4rem;
  width: 5.7333rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
  :hover {
    background-color: ${Variables.colors.complementary_100};
  }
`;

export const HighlightedCalendarMonth = styled(CalendarMonthCell)`
  background-color: ${MAIN_DARK_COLOR};
  color: ${Variables.colors.complementary};
  position: relative;
  &:hover {
    background-color: ${MAIN_DARK_COLOR};
    color: ${Variables.colors.complementary};
  }
`;
